// import moment from 'moment';
import React, { useState } from 'react';
import { TableInput } from '../../../components/common';
// import DatePickerMui from '../../../components/common/DatePickerMui';
// import formatDate from '../../../components/common/formatDate';
import { TableCompHead } from '../../../components/ui';
import AutocompleteMuiCustom from '../../../components/common/AutocompleteMuiCustom';
// import { MenuItem } from '@mui/material';
// import CustomSelect from '../../../components/common/SelectField';
import { useQuery } from '../../../hooks/UseQuery';

interface IProps {
  moduleData: any;
  process: any;
  setModuleData: any;
  isView: boolean;
}
const THead = ({ moduleData, isView, process, setModuleData }: IProps) => {
  const [render, setRender] = useState(false);
  const part_number = useQuery('part_number');
  const part_name = useQuery('part_name');
  const customer_name = useQuery('customer_name');

  return (
    <thead>
      <TableCompHead
        colSpan={9}
        rowSpan={1}
        labels={['DOCUMENT NO. - ']}
        values={['FM/QA/02  OP10/REV00']}
        heading="Process Standard"
      />
      <tr>
        <th colSpan={2} align="left">
          PART NO. :
        </th>
        <th colSpan={2} align="left">
          {part_number}
        </th>
        <th colSpan={2} align="left">
          CUSTOMER NAME :
        </th>
        <th colSpan={3} align="left">
          {customer_name}
        </th>
      </tr>
      <tr>
        <th colSpan={2} align="left">
          Part Name:
        </th>
        <th colSpan={2} align="left">
          {part_name}
        </th>
        <th colSpan={2} align="left">
          MODEL:
        </th>
        <th colSpan={3} align="left">
          <TableInput
            name="model"
            type="text"
            value={moduleData.model}
            onChange={(e) => {
              moduleData.model = e.target.value;
              setRender((prev) => !prev);
            }}
            isView={isView}
          />
        </th>
      </tr>
      <tr>
        <th colSpan={2} align="left">
          MATERIAL SPECIFICATION :
        </th>
        <th colSpan={2} align="left">
          <TableInput
            name="material_spec"
            type="text"
            value={moduleData.material_spec}
            onChange={(e) => {
              moduleData.material_spec = e.target.value;
              setRender((prev) => !prev);
            }}
            isView={isView}
          />
        </th>
        <th colSpan={2} align="left">
          ASSY. PART NO. (CUSTOMER) :
        </th>
        <th colSpan={3} align="left">
          <TableInput
            name="aasy_part_no_customer"
            type="text"
            value={moduleData.aasy_part_no_customer}
            onChange={(e) => {
              moduleData.aasy_part_no_customer = e.target.value;
              setRender((prev) => !prev);
            }}
            isView={isView}
          />
        </th>
      </tr>
      <tr>
        <th colSpan={2} align="left">
          RAW MATERIAL SIZE : (Thickness * Width * Length)
        </th>
        <th colSpan={2} align="left">
          <TableInput
            name="raw_material_size"
            type="text"
            value={moduleData.raw_material_size}
            onChange={(e) => {
              moduleData.raw_material_size = e.target.value;
              setRender((prev) => !prev);
            }}
            isView={isView}
          />
        </th>
        <th colSpan={2} align="left">
          ASSY. NAME (CUSTOMER) :
        </th>
        <th colSpan={3} align="left">
          <TableInput
            name="assy_name_customer"
            type="text"
            value={moduleData.assy_name_customer}
            onChange={(e) => {
              moduleData.assy_name_customer = e.target.value;
              setRender((prev) => !prev);
            }}
            isView={isView}
          />
        </th>
      </tr>
      <tr>
        <th colSpan={2} align="left">
          OPERATION NO. :
        </th>
        <th colSpan={1} align="left">
          {moduleData?.process_no}
        </th>
        <th colSpan={2}>OPERATION NAME : </th>
        <th colSpan={3}>
          {isView ? (
            moduleData.process_name
          ) : (
            <AutocompleteMuiCustom
              id={'process_name'}
              label=""
              option_name={'process_name'}
              value={moduleData || ''}
              arrayofObj={process}
              onChange={(e, value) => {
                setModuleData(value || {});
              }}
            />
          )}
        </th>
        <th>NEXT OPERATION : BENDING</th>
      </tr>
      <tr>
        <th colSpan={9} align="left" style={{ fontSize: '2rem' }}>
          DIE SETTING DETAILS ( ) :
        </th>
      </tr>
      <tr>
        <th colSpan={2} align="left">
          PRESS TONNAGE :
        </th>
        <th colSpan={1} align="left">
          <TableInput
            name="press_tonnage"
            type="text"
            value={moduleData.press_tonnage}
            onChange={(e) => {
              moduleData.press_tonnage = e.target.value;
              setRender((prev) => !prev);
            }}
            isView={isView}
          />
        </th>
        <th colSpan={2} align="left">
          FIXED PRESS :
        </th>
        <th colSpan={1} align="left">
          <TableInput
            name="fixed_press"
            type="text"
            value={moduleData.fixed_press}
            onChange={(e) => {
              moduleData.fixed_press = e.target.value;
              setRender((prev) => !prev);
            }}
            isView={isView}
          />
        </th>
        <th colSpan={2} rowSpan={3} align="left">
          SHUT HEIGHT CHECKED :
        </th>
        <th colSpan={1} rowSpan={3} align="left">
          <TableInput
            name="shut_height_checked"
            type="text"
            value={moduleData.shut_height_checked}
            onChange={(e) => {
              moduleData.shut_height_checked = e.target.value;
              setRender((prev) => !prev);
            }}
            isView={isView}
          />
        </th>
      </tr>
      <tr>
        <th colSpan={2} align="left">
          NO. OF CLAMP BOLTS
        </th>
        <th colSpan={1} align="left">
          <TableInput
            name="no_of_clamp_bolt"
            type="text"
            value={moduleData.no_of_clamp_bolt}
            onChange={(e) => {
              moduleData.no_of_clamp_bolt = e.target.value;
              setRender((prev) => !prev);
            }}
            isView={isView}
          />
        </th>
        <th colSpan={2} align="left">
          CUSHION PRESSURE
        </th>
        <th colSpan={1} align="left">
          <TableInput
            name="cushion_pressure"
            type="text"
            value={moduleData.cushion_pressure}
            onChange={(e) => {
              moduleData.cushion_pressure = e.target.value;
              setRender((prev) => !prev);
            }}
            isView={isView}
          />
        </th>
      </tr>
      <tr>
        <th colSpan={2} align="left">
          PANEL CHECKER NO.
        </th>
        <th colSpan={1} align="left">
          <TableInput
            name="pannel_checker_no"
            type="text"
            value={moduleData.pannel_checker_no}
            onChange={(e) => {
              moduleData.pannel_checker_no = e.target.value;
              setRender((prev) => !prev);
            }}
            isView={isView}
          />
        </th>
        <th colSpan={2} align="left">
          CUSHION PIN HEIGTH ABOVE BOLSTER
        </th>
        <th colSpan={1} align="left">
          <TableInput
            name="chushin_pin_heigth"
            type="text"
            value={moduleData.chushin_pin_heigth}
            onChange={(e) => {
              moduleData.chushin_pin_heigth = e.target.value;
              setRender((prev) => !prev);
            }}
            isView={isView}
          />
        </th>
      </tr>
      <tr>
        <th colSpan={9} align="left">
          COMPONENT SKETCH:-
        </th>
      </tr>
      <tr>
        <th
          colSpan={9}
          style={{
            height: '500px',
          }}
        >
          <img height="100%" width="auto" src={moduleData.image} alt="image" />
        </th>
      </tr>
      <tr>
        <th colSpan={9} style={{ fontSize: '2rem' }}>
          ऑपरेटर के लिए कार्य निर्देश
        </th>
      </tr>
      <tr>
        <th align="left" colSpan={9}>
          1. ऑपरेटर काम शुरू करने से पहले मशीन की अच् छी तरह से सफाई करें
        </th>
      </tr>
      <tr>
        <th align="left" colSpan={9}>
          2. ऑपरेटर काम शुरू करने से पहले उई के नट बोल्ट चेक करले
        </th>
      </tr>
      <tr>
        <th align="left" colSpan={9}>
          3. ऑपरेटर पहले पीस को खुद चेक करके फिर सेटिंग अप्रूवल क्वालिटी
          इंस्पेक्टर से ले
        </th>
      </tr>
      <tr>
        <th align="left" colSpan={9}>
          4. ऑपरेटर पीस गलत आने पर इंस्पेक्टर या सुपरवाइजर को सूचित करें
        </th>
      </tr>
      <tr>
        <th align="left" colSpan={9}>
          5. ऑपरेटर सेफ्टी यन्त्र पहनकर ही काम करें
        </th>
      </tr>
      <tr>
        <th align="left" colSpan={9}>
          6. किसी भी असुविधा की स्तिथि में ऑपरेटर लाइन सुपरवाइजर को सूचित करें
        </th>
      </tr>
      <tr>
        <th align="left" colSpan={9}>
          7-चेक करे की पार्ट में होल सही होना चाहिए
        </th>
      </tr>
      <tr>
        <th colSpan={9} align="left">
          CHECK POINT FOR PRODUCTION ( )
        </th>
      </tr>
      <tr>
        {[
          'S.No.',
          'PARAMETER',
          'SPECIFICATION',
          'MEASUREMENT TECHNIQUES',
          'SAMPLE',
          'RECORDING',
          'INSPECTED BY',
          'REACTION PLAN',
        ].map((item, index) => (
          <React.Fragment key={`heading_${index}`}>
            <th
              style={{ height: '80px' }}
              colSpan={item === 'SAMPLE' ? 2 : 1}
              rowSpan={item === 'SAMPLE' || item === 'RECORDING' ? 1 : 2}
            >
              {item}
            </th>
          </React.Fragment>
        ))}
      </tr>
      <tr>
        <th>SIZE</th>
        <th>FREQUENCY</th>
        <th>Y / N</th>
      </tr>
    </thead>
  );
};

export default THead;
